import React, { Component } from 'react';
import '../resources/bootstrap/themes/bootstrap.min.css';
import '../resources/css/Login.css';
import '../resources/css/App.css';
import logo from '../resources/images/logo.png';
import {
  firebaseDb,
  firebaseAuth,
} from '../lib/firebase/firebase';
var SHA256 = require("crypto-js/sha256");

class Login extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      email:"",
      password:"",
      loading:false,
      //message:{type:'danger',text:"Wrong username or email"},
    };
  }

  componentDidMount(){
  }

  handleChangeEmail(event) {
    this.setState({email: event.target.value});
  }

  handleChangePassword(event) {
    this.setState({password: event.target.value});
  }

  async login() {
      try {
          this.setState({
              loading:true,
          });
          await firebaseAuth.signInWithEmailAndPassword(this.state.email, this.state.password);
          var currentUser = firebaseAuth.currentUser;
          var user = {};
          var _self = this;
          firebaseDb.ref('users/'+currentUser.uid).once('value',function(s){
            if(!s.exists()){  
              console.log("FUCKIT")
            }else{
              _self.setState({
                  message:{type:"success",text:"Logged in successfuly!"},
                  password:"",
                  loading:false,
                  user:s.val(),
              });
              //firebaseDb.ref('users/'+currentUser.uid+"/last_login").set((new Date()).toISOString());
            }
          });
      } catch (error) {
          this.setState({
              message: {type:"danger",text:error.toString()},
              password:"",
              loading:false,
          })
      }

  }

  validateForm(){
    if(this.state.email==="")
      return {valid:false,message:'Invalid email.'};
    if(this.state.password==="")
      return {valid:false,message:'Invalid password.'};

    return {valid:true,}
  }

  onHandleSubmit(event){
    var isValid = this.validateForm();
    if(isValid.valid){
      if(event==='login'){
        this.login();
      }
    }else{
      this.setState({message:{type:"danger",text:isValid.message}})
    }
  }

  render() {
    var message = [];
    if(this.state.message){
      message = (
        <div className={"alert alert-"+this.state.message.type}>
          {this.state.message.text}
        </div>
      );
    }
    var loading = [];
    if(this.state.loading){
      loading =(
          <div>
            <a className="btn btn-default btn-block" disabled>Signing in...</a>
          </div>
      );
    }else{
      loading =(
          <div>
            <a onClick={this.onHandleSubmit.bind(this,"login")} className="btn btn-primary btn-block">Login</a>
          </div>
      );      
    }
    return (
      <div className="container">
        <form className="form-signin">
          <div className="panel panel-default">
            <div className="panel-body">
                <div className="logoContainer row">
                  <div className="logoContainer col-md-12">
                    <img className="logo" src={logo} alt="logo" height="100" />
                  </div>
                </div>
                <label className="sr-only">Email address</label>
                <input 
                  type="email" 
                  id="inputEmail" 
                  className="form-control" 
                  placeholder="Email address" 
                  value={this.state.email}
                  onChange={this.handleChangeEmail.bind(this)}
                  required 
                  autoFocus />
                <label className="sr-only">Password</label>
                <input 
                  type="password" 
                  id="inputPassword" 
                  className="form-control" 
                  value={this.state.password}
                  onChange={this.handleChangePassword.bind(this)}
                  placeholder="Password" 
                  required/>
                {loading}
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              {message}
            </div>
          </div>

        </form>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/views/Login.js